"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILockBadge = _interopRequireDefault(require("UIComponents/badge/UILockBadge"));

var _UILockedFeature = _interopRequireDefault(require("ui-addon-upgrades/decorators/UILockedFeature"));

var _RequestState = require("lead-flows-ui/utils/RequestState");

var _UpgradeProperties = require("lead-flows-ui/constants/UpgradeProperties");

var FormFieldCreationButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldCreationButton, _Component);
  (0, _createClass2.default)(FormFieldCreationButton, null, [{
    key: "propTypes",
    get: function get() {
      return {
        fieldLabel: _react.PropTypes.string.isRequired,
        isValid: _react.PropTypes.bool.isRequired,
        creationRequestState: _react.PropTypes.instanceOf(_RequestState.RequestState).isRequired,
        onClick: _react.PropTypes.func.isRequired,
        isTeaser: _react.PropTypes.bool.isRequired
      };
    }
  }]);

  function FormFieldCreationButton() {
    var _this;

    (0, _classCallCheck2.default)(this, FormFieldCreationButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldCreationButton).call(this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FormFieldCreationButton, [{
    key: "langKey",
    value: function langKey(key) {
      return "leadFlowEditor.formFieldEditor." + key;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      var creationRequestState = this.props.creationRequestState;
      return creationRequestState.isPending();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.isDisabled()) {
        return;
      }

      this.props.onClick();
    }
  }, {
    key: "renderButtonMessage",
    value: function renderButtonMessage() {
      var _this$props = this.props,
          isTeaser = _this$props.isTeaser,
          fieldLabel = _this$props.fieldLabel,
          creationRequestState = _this$props.creationRequestState;

      if (creationRequestState.isPending()) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('creatingFormField')
        });
      }

      if (creationRequestState.isFailed()) {
        var _message = creationRequestState.message;
        return _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey("errors." + _message)
        });
      }

      var messageLang = 'createFormFieldTeaser';

      if (!isTeaser) {
        messageLang = 'createNewFormField';
      }

      var message = _react.default.createElement("span", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey(messageLang),
        options: {
          fieldName: fieldLabel
        }
      }));

      return message;
    }
  }, {
    key: "render",
    value: function render() {
      var isTeaser = this.props.isTeaser;
      var disabledClassName = this.isDisabled() ? 'disabled' : undefined;

      if (isTeaser) {
        return _react.default.createElement(_UILockedFeature.default, {
          modalKey: "leadflows-custom-props",
          modalMountDelay: 0,
          upgradeData: {
            app: _UpgradeProperties.LEAD_FLOWS_APP,
            screen: 'dyno-editor-add-form-field',
            upgradeProduct: _UpgradeProperties.MARKETING_STARTER_PRODUCT,
            uniqueId: 'custom-fields-prompt'
          }
        }, _react.default.createElement(_UIFlex.default, {
          className: (0, _classNames.default)('create-field-clickable', disabledClassName),
          direction: "row"
        }, _react.default.createElement(_UIBox.default, {
          grow: 1
        }, this.renderButtonMessage(), _react.default.createElement(_UILockBadge.default, {
          className: "m-left-2"
        }))));
      } // Not using UIButton here because something else latches onto
      // button click events and breaks the intended behaviour.


      return _react.default.createElement(_UIFlex.default, {
        className: (0, _classNames.default)('create-field-clickable', disabledClassName),
        direction: "row",
        onClick: this.handleClick
      }, _react.default.createElement(_UIBox.default, {
        grow: 1
      }, this.renderButtonMessage()));
    }
  }]);
  return FormFieldCreationButton;
}(_react.Component);

exports.default = FormFieldCreationButton;
module.exports = exports.default;